import { createContext, ReactElement, useContext } from "react";
import GetMembros, { ResponseMembrosCheckin } from "../services/getMembros";



export const GetContexAcolher = createContext<ResponseMembrosCheckin>(null);

export const ProviderGetMembrosAcolher = ({children}: { children: ReactElement | ReactElement[] }) => {
  const services = GetMembros();
  return (
    <GetContexAcolher.Provider value={services}>
      {children}
    </GetContexAcolher.Provider>
  )
}

export const useAcolherVisitantes = () => {
  const context = useContext(GetContexAcolher);
  return context;
}
